// extracted by mini-css-extract-plugin
export default {"links":"SeriesDetailsLinks-links-cHw2_","link":"SeriesDetailsLinks-link-RfjeR","linkLabel":"SeriesDetailsLinks-linkLabel-SAKtg Label-label-DYldh"};